import "regenerator-runtime/runtime";
import React from "react";
import { login, logout } from "./utils";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Home } from './components/home';
import { Collection } from './components/collection';
import './global.css';

export default function App() {

  return (
    <BrowserRouter>
      <Routes>
        <Route 
          exact 
          path='/' 
          element={
            <Home 
              isSignedIn={window.walletConnection.isSignedIn()} 
              connectAction={window.walletConnection.isSignedIn() ? logout : login}
            />
          }
        />

        <Route 
          path='/collection/:name' 
          element={
            <Collection 
            isSignedIn={window.walletConnection.isSignedIn()} 
            connectAction={window.walletConnection.isSignedIn() ? logout : login}
            />
          }
        />

      </Routes>
  </BrowserRouter>
  );
}
